export const subscriptionConstants = {
  // Get Subscription Plan
  getSubscriptionPlanRequest: "GET_SUBSCRIPTION_PLAN_REQUEST",
  getSubscriptionPlanSuccess: "GET_SUBSCRIPTION_PLAN_SUCCESS",
  getSubscriptionPlanFailure: "GET_SUBSCRIPTION_PLAN_FAILURE",

  // Create Subscription
  createSubscriptionRequest: "CREATE_SUBSCRIPTION_REQUEST",
  createSubscriptionSuccess: "CREATE_SUBSCRIPTION_SUCCESS",
  createSubscriptionFailure: "CREATE_SUBSCRIPTION_FAILURE",

  // Get Subscription Status
  getSubscriptionStatusRequest: "GET_SUBSCRIPTION_STATUS_REQUEST",
  getSubscriptionStatusSuccess: "GET_SUBSCRIPTION_STATUS_SUCCESS",
  getSubscriptionStatusFailure: "GET_SUBSCRIPTION_STATUS_FAILURE",

  // Get Order Status
  getOrderStatusRequest: "GET_ORDER_STATUS_REQUEST",
  getOrderStatusSuccess: "GET_ORDER_STATUS_SUCCESS",
  getOrderStatusFailure: "GET_ORDER_STATUS_FAILURE",

  // Sync Plans
  syncPlansRequest: "SYNC_PLANS_REQUEST",
  syncPlansSuccess: "SYNC_PLANS_SUCCESS",
  syncPlansFailure: "SYNC_PLANS_FAILURE",

  // Get All Plans
  getAllPlansRequest: "GET_ALL_PLANS_REQUEST",
  getAllPlansSuccess: "GET_ALL_PLANS_SUCCESS",
  getAllPlansFailure: "GET_ALL_PLANS_FAILURE",

  // Get User Subscription Status
  getUserSubscriptionStatusRequest: "GET_USER_SUBSCRIPTION_STATUS_REQUEST",
  getUserSubscriptionStatusSuccess: "GET_USER_SUBSCRIPTION_STATUS_SUCCESS",
  getUserSubscriptionStatusFailure: "GET_USER_SUBSCRIPTION_STATUS_FAILURE",
};

export const subscription_plan = {
  free: "Free Trial",
  standard: "Standard",
  pro: "Professional",
  ultimate: "Enterprise"
};

// Free Trial Constants
export const FREE_TRIAL_DAYS = 7;
export const FREE_TRIAL_EXPIRED_MESSAGE = "Your free trial has expired. Please upgrade to continue using the service.";
export const FREE_TRIAL_EXPIRING_SOON_MESSAGE = "Your free trial is expiring soon. Upgrade now to avoid service interruption.";
export const SUBSCRIPTION_EXPIRED_MESSAGE = "Your subscription has expired. Please renew to continue.";
